import { message } from 'antd';

export const SUBSCRIPTION_ACCESS_UPDATED_EVENT =
  "elsa:subscription-access-updated";

export const emitSubscriptionAccessUpdate = (payload) => {
  if (typeof window === "undefined" || !payload) return;
  if (isSubscriptionRestrictionCode(payload.code) && payload.message) {
    message.error({
      key: 'subscription-restriction',
      content: payload.message,
      duration: 6,
    });
  }
  window.dispatchEvent(
    new CustomEvent(SUBSCRIPTION_ACCESS_UPDATED_EVENT, {
      detail: payload,
    }),
  );
};

export const isSubscriptionRestrictionCode = (code) =>
  ["SUBSCRIPTION_READ_ONLY", "SUBSCRIPTION_SUSPENDED", "SUBSCRIPTION_ACTION_RESTRICTED"].includes(
    String(code || ""),
  );
